package com.example.mystybag.appCore.model.pages

import com.example.mystybag.sharedmodels.project.database.UserReservationModel

/** Loaded per reservation for the card: address and collect window from location + bag. */
data class ReservationCardExtra(
    val pickupAddress: String? = null,
    val locationLatitude: Double = 0.0,
    val locationLongitude: Double = 0.0,
    val collectWindowLabel: String? = null,
    val locationAverageRating: Double? = null,
    /** From `getBagDetails` when list response omits bag name. */
    val bagTitleFromDetails: String? = null
)

data class DeliveryPageUIState(
    val isLoading: Boolean = false,
    val reservations: List<UserReservationModel> = emptyList(),
    /** reservationId -> extra (address, collect window). Filled after loading location + bag per reservation. */
    val reservationExtras: Map<Long, ReservationCardExtra> = emptyMap(),
    val errorMessage: String? = null,
    /** 0 = Active, 1 = History */
    val selectedTabIndex: Int = 0,
    /** Set when switching to History after swipe-to-confirm; UI scrolls list to top then clears this. */
    val scrollHistoryToTopPending: Boolean = false
)

